import { render, staticRenderFns } from "./PayLoading.vue?vue&type=template&id=8003ba3e&scoped=true"
import script from "./PayLoading.vue?vue&type=script&lang=js"
export * from "./PayLoading.vue?vue&type=script&lang=js"
import style0 from "./PayLoading.vue?vue&type=style&index=0&id=8003ba3e&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8003ba3e",
  null
  
)

export default component.exports